import { useState, useRef } from "react";
import CustomHook from "./CustomHook";

function Contacts() {
  const [listContacts] = useState([
    {
      title: "Telegram",
      value: "https://t.me/DmitriyWork201",
      icon: "https://ygamijs.github.io/YgamiJS/src/img/icons/icons8-telegram.svg",
    },
    {
      title: "Email",
      value: "dmitriywork201@gmail.com",
      icon: "https://ygamijs.github.io/YgamiJS/src/img/icons/icons8-gmail.svg",
    },
    {
      title: "WhatsApp",
      value: "https://wa.me/79272570537",
      icon: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/whatsapp-color-icon.svg",
    },
    {
      title: "VK",
      value: "https://vk.com/id832660832",
      icon: "https://ygamijs.github.io/YgamiJS/src/img/icons/icons8-vk.svg",
    },
    {
      title: "GitHub",
      value: "https://github.com/YgamiJS",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7cmmOu4xUkNNZlk-qh4r47i9n6R1mLQD-3Q&s",
    },
  ]);

  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  return (
    <section className="contacts" ref={scrollTab} id="contacts">
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        Контакты
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}></div>
      <div className="list" ref={(el) => el && divs.current.push(el)}>
        {listContacts.map((value, key) => (
          <div className="item" key={key}>
            <h3
              style={{ display: "flex", gap: "5px", justifyContent: "center" }}
            >
              <img
                width={25}
                height={25}
                src={value.icon}
                alt=""
                fetchpriority="low"
                loading="lazy"
              />
              <span>{value.title}</span>
            </h3>
            <div className="container">
              <span className="link-text">
                <a
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                  href={
                    value.value === "dmitriywork201@gmail.com"
                      ? "https://www.google.com/intl/ru/gmail/about/#inbox?compose=new"
                      : value.value
                  }
                >
                  {value.value}
                </a>
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Contacts;
